import { map, values, reduce, flow } from 'lodash/fp';

// output: array of object { itemId, locationId, zoneId, quantity }
const toAddBodyFormat = reduce(
  (
    all,
    {
      inventoryItemId: itemId,
      inventoryLocationId: locationId,
      inventoryLocationZoneId: zoneId,
      quantity
    }
  ) => [...all, { itemId, locationId, zoneId, quantity }],
  []
);

// output: array of object { id, quantity }
const toUpdateFormat = values;

// output: array of orderItem id
const toDeleteFormat = flow(
  values,
  map('id')
);

export default orderAdjustment => ({
  add: toAddBodyFormat(orderAdjustment.add),
  update: toUpdateFormat(orderAdjustment.update),
  delete: toDeleteFormat(orderAdjustment.delete)
});
